import axios from "@/axios";

const getPatentsTAGByRut = async (rut) => {
  const patentsResponse = await axios.get(`/PatentesByRut/${rut}`)
  const patents = patentsResponse.data.map(patentResponse => patentResponse.patente);
  return patents;
}

const getPatentsSinisterByRut = async (rut) => {
  const patentsResponse = await axios.get(`/PatentesSiniestroByRut/${rut}`)
  const patents = patentsResponse.data.map(patentResponse => patentResponse.patente);
  return patents;
}

const getPatentsMultasByRut = async (rut) => {
  const patentsResponse = await axios.get(`/PatentesMultaByRut/${rut}`)
  const patents = patentsResponse.data.map(patentResponse => patentResponse.patente);
  return patents;
}

const getPatentsOrdenByRut = async (rut) => {
  const patentsResponse = await axios.get(`/PatentesOrdenByRut/${rut}`)
  const patents = patentsResponse.data.map(patentResponse => patentResponse.patente);
  return patents;
}

const getReimbursableExpensePatentByRut = async (rut) => {
  const patentsResponse = await axios.get(`/PatentesGastoReembolsableRacByRut/${rut}`)
  const patents = patentsResponse.data.map(patentResponse => patentResponse.patente);
  return patents;
}

export default {
  getPatentsTAGByRut,
  getPatentsSinisterByRut,
  getPatentsOrdenByRut,
  getPatentsMultasByRut,
  getReimbursableExpensePatentByRut
};
